export const state = {
	status: false,
	modalName: [],
	action: '',
	callback: null,
	data: {},

	cancelAction: '',
	cancelData: {},

	content: {},
	loading: false
}

export const mutations = {
	TOGGLE_MODAL (state, {status = false, modalName = '', action = '', callback = null, data = '', cancelAction = '', cancelData = '', content = {}}) {
		if (status) {
			if (!state.modalName.includes(modalName)) state.modalName.push(modalName)
		} else {
			state.modalName.pop()
		}

		// status && !state.modalName.includes(modalName) ? state.modalName.push(modalName) : state.modalName.pop()
		state.status = status
		state.action = action
		state.callback = callback
		state.data = data
		state.cancelAction = cancelAction
		state.cancelData = cancelData
		state.content = content
		state.loading = false
	},

	TOGGLE_OVERFLOW (state) {
		var body = document.querySelector('body')
		state.modalName.length > 0 ? body.style.overflowY = 'hidden' : body.style.overflowY = 'auto'
	}
}

export const actions = {
	async approveModal ({ commit, dispatch, state }, payload) {
		state.loading = true
		if (state.action) {
			await dispatch(state.action, state.data)
		}
		if (typeof (state.callback) === 'function') {
			state.callback()
		}

		state.loading = false
	},

	async cancelModal ({ commit, dispatch, state }, payload) {
		state.loading = true
		if (state.cancelAction) {
			await dispatch(state.cancelAction, state.cancelData)
			state.loading = false
		}
	},

	async toggleModal ({ commit }, payload) {
		await commit('TOGGLE_MODAL', payload)
		await commit('TOGGLE_OVERFLOW', payload)
	}
}

export const getters = {
}

export default {
	state,
	mutations,
	actions,
	getters,
	namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/global/modal.js